module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "small-box",
    class: _vm.bgColor
  }, [_c('div', {
    staticClass: "inner"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.description))])]), _vm._v(" "), _c('div', {
    staticClass: "icon"
  }, [_c('i', {
    staticClass: "ion",
    class: _vm.icon
  })]), _vm._v(" "), _c('a', {
    staticClass: "small-box-footer",
    attrs: {
      "href": "#"
    },
    on: {
      "click": _vm.moreEvent
    }
  }, [_vm._v(_vm._s(_vm.moreText) + " "), _c('i', {
    staticClass: "fa fa-arrow-circle-right"
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4be4ae02!./~/vue-loader/lib/selector.js?type=template&index=0!./src/widgets/VASmallBox.vue
// module id = 803
// module chunks = 0